<script setup lang="ts">
import { useFetchTransactionListByAddress } from '~/api/service/address/transaction/list/index.service'
import DetailsBox from '~/components/box/DetailsBox.vue'
import TransactionsTable from '~/components/table/transactions/TransactionsTable.vue'
import BcPagination from '~/ui/Pagination/BcPagination.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'

const address = useRoute().params.address as string

const ellipsisAddress = computed(() => `${address.slice(0, 8)}...${address.slice(-6)}`)
useSeoMeta(getMeta(`Address ${ellipsisAddress.value}`, `Explore details of Address ${ellipsisAddress.value}`))

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 25
})

const { data, isLoading } = useFetchTransactionListByAddress(address, pagination)

useHead(getBreadCrumb())
</script>

<template>
  <div class="relative">
    <DetailsBox class="mt-4">
      Showing the last <span class="font-bold text-primary">{{ data?.viewCount }}</span> records from {{
        data?.totalCount
      }} results
      <template #pagination>
        <BcPagination
          v-if="data?.VCNT"
          v-model="pagination"
          :row-per-page-list="rowPerPageList"
          :total-count="data.VCNT"
          hide-rows-per-page
        />
      </template>
    </DetailsBox>
  </div>

  <Card
    class="mt-4"
  >
    <TransactionsTable
      :is-loading="isLoading"
      :rows="data?.TRXLIST || []"
      :row-cnt="pagination.rowPerPage"
    />
    <BcPagination
      v-if="data?.VCNT"
      v-model="pagination"
      :row-per-page-list="rowPerPageList"
      :total-count="data.VCNT"
    />
  </Card>
</template>

<style scoped>

</style>